import { css } from '@firebolt-dev/css'
import { useEffect, useState } from 'react'

export function UIEditorFieldText({ placeholder, value, onChange }) {
  const [localValue, setLocalValue] = useState(value)
  useEffect(() => {
    if (localValue !== value) setLocalValue(value)
  }, [value])
  return (
    <div
      className='fieldtext'
      css={css`
        flex: 1;
        display: flex;
        align-items: center;

        background: var(--bg4);
        border-radius: 5px;
        padding: 0 12px;
        input {
          flex: 1;
          width: 100%;
          height: 34px;
          /* text-align: right; */
          cursor: inherit;
          &::selection {
            background-color: white;
            color: rgba(0, 0, 0, 0.8);
          }
        }
      `}
    >
      <input
        type='text'
        value={localValue || ''}
        placeholder={placeholder}
        // onFocus={e => e.target.select()}
        onChange={e => setLocalValue(e.target.value)}
        onKeyDown={e => {
          if (e.code === 'Enter') {
            e.preventDefault()
            e.target.blur()
          }
        }}
        onBlur={e => {
          onChange(localValue)
        }}
      />
    </div>
  )
}
